module.exports = __webpack_public_path__ + "Stars-no-reviews.8c3d66bdde40e1b425b893e8be93ab5b.png";